<template>
    <div>
        <div class=" mb-5">
            <!-- shape Hero -->
            <section class="section-shaped my-0 pb-lg-5">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex pb-3">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3 ">My Profile
                                </h1>
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container shape-container d-flex border rounded">
                    <div class="col px-0">
                        <div v-if="successMessage != null">
                            <base-alert type="primary" dismissible>
                                <span class="alert-inner--text"> {{successMessage}}</span>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </base-alert>
                        </div>
                        <base-alert v-if="errors.length" type="danger">
                            <b>You have the following error(s):</b>
                            <li v-for="error in errors" :key="error">{{ error }}</li>
                        </base-alert>
                        <div class="row no-gutters bg-white">
                            <div class="col-md-3 " style="border-right: 1px solid #e0e0e0">
                                <div class="card-body">
                                    <div class="filter-bar ui basic segment grid">
                                        <div class="ui form">
                                            <div class="inline field">
                                                <h6 class="heading-small text-muted mb-4">Account DashBoard</h6>
                                                <hr class="my-4 mb-0" />
                                                <div class="list-group list-group-flush">
                                                    <router-link  :to="{ name: 'account', params: { storeName: $route.params.storeName, accountName: $route.params.accountName}}" class="list-group-item list-group-item-action border-0 active"> Account Information</router-link>
                                                    <router-link  :to="{ name: 'address', params: { storeName: $route.params.storeName, accountName: $route.params.accountName}}" class="list-group-item list-group-item-action border-0"> Addresses</router-link>
                                                    <router-link :to="{ name: 'orders', params: { storeName: $route.params.storeName, accountName: $route.params.accountName}}" class="list-group-item list-group-item-action border-0">My Orders</router-link>
                                                  </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="card-header border-0">
                                    <div class="row align-items-center">
                                        <div class="col-md-12"></div>
                                        <div class="col-md-3">
                                        </div>
                                        <div class="col-md-9 text-right">
                                            <a-button type="primary" v-if="viewMode" class="btn float-right ml-1 btn-primary btn-sm" @click="editDetails">Edit</a-button>
                                            <a-button type="primary" v-if="!viewMode" class="btn float-right ml-1 btn-primary btn-sm" @click="saveDetails">Save</a-button>
                                            <a-button type="primary" v-if="!viewMode" class="btn float-right ml-1 btn-secondary btn-sm" @click="cancelEditDetails">Cancel</a-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <base-input :disabled="viewMode" class="col" alternative="" label="First Name" v-model="customerDetails.first_name" input-classes="form-control" required />
                                        <base-input :disabled="viewMode" class="col" alternative="" label="Last Name" v-model="customerDetails.last_name" input-classes="form-control" required />
                                    </div>
                                    <div class="row">
                                        <base-input :disabled="viewMode" class="col" alternative="" label="Email" type="email" v-model="customerDetails.email" input-classes="form-control" required />
                                        <base-input :disabled="viewMode" class="col" alternative="" label="Mobile Number" type="number" v-model="customerDetails.mobile" input-classes="form-control" required />
                                    </div>
                                    <div class="row">
                                        <base-input class="col" label="Birthdate" >
                                            <a-date-picker :disabled="viewMode" size="large" v-model="customerDetails.birthday" :format="dateFormat" style="width: 100%;"/>
                                        </base-input>
                                        <base-input class="col" label="Gender"> 
                                            <a-select :disabled="viewMode" size="large" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="customerDetails.gender">
                                                <a-select-option key="F" value="F">FEMALE</a-select-option>
                                                <a-select-option key="M" value="M">MALE</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                    <div class="row">
                                        <base-input :disabled="viewMode" class="col" alternative="" label="New Password" type="password" v-model="customerDetails.password" input-classes="form-control"/>
                                        <base-input :disabled="viewMode" class="col" alternative="" label="Confirm Password" type="password" v-model="customerDetails.confirm_password" input-classes="form-control"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
    </div>
</template>
<script>
import secureStorage from '../../controllers/secureStorage.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js'
import { mapState, mapActions } from 'vuex'
export default {
    components: {
        HTTPRequest
    },
    computed: {
        ...mapState(['endPoint', 'parameters'])
    },
    data() {
        return {
            email:null,
            password:null,
            customerDetails:{},
            tempCustomerDetails:{},
            dateFormat: 'MM-DD-YYYY',
            viewMode:true,
            errors:[],
            successMessage:null,
        }
    },
    mounted: async function(){
        var autoLogin = secureStorage.getItem("ecomLoggedIn")
        if(autoLogin == true){
            this.$emit('showFooterAndHeader', event)
            this.$emit('hideSearchInput', event)
            this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
            this.storeDetails = secureStorage.getItem("SalesChannelDetails")
            this.tempCustomerDetails = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin")
            this.customerDetails = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin")
            console.log(this.customerDetails)
            if (secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus") != true){
                this.$router.push({ name: 'store', params:{storeId:this.$route.params.storeId }})
            }
        }else{
            this.$router.push({ name: 'loading_screen', params: { returnUrl: 'account', storeId:this.$route.params.storeId }})
        }
    },
    methods:{
        editDetails(){
            this.viewMode = false
        },
        cancelEditDetails(){
            this.viewMode = true
        },
        CreateValidation(){
            this.errors = [];
            this.errors.push(ValidateField.required('First Name', this.customerDetails.first_name));
            this.errors.push(ValidateField.required('Last Name', this.customerDetails.last_name));
            this.errors.push(ValidateField.required('Email', this.customerDetails.email));
            this.errors.push(ValidateField.required('Email', this.customerDetails.mobile));
            if (this.customerDetails.password!=null){
                this.errors.push(ValidateField.required('Confirm Password', this.customerDetails.confirm_password));
                this.errors.push(ValidateField.matchData('Password',this.customerDetails.password,this.customerDetails.confirm_password));
            }
            this.errors = this._.compact(this.errors);
            return this.errors.length;
        },
        saveDetails: async function(){
            if(!this.CreateValidation()) {
                var CustomerPayload = {
                    customer:{
                        first_name:this.customerDetails.first_name,
                        last_name:this.customerDetails.last_name,
                        email:this.customerDetails.email,
                        mobile:this.customerDetails.mobile,
                        gender:this.customerDetails.gender,
                        birthday:this.customerDetails.birthday,
                    }
                }
                if (this.customerDetails.password!=null){
                    details.customer.password = this.customerDetails.password
                }
                var post_request = await HTTPRequest.putRequest(this.endPoint + 'sales_channel_customers/'+this.customerDetails.id+'?name='+this.storeDetails.name+'&account_id='+this.storeDetails.account_id, null, CustomerPayload)    
                 if (post_request["error"] == undefined) {
                    this.$notification['success']({
                        message: 'Success',
                        description: "Congratulations, your account has been successfully updated",
                    });
                    secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin",post_request)
                    this.viewMode = true
                }else{
                    this.errors = post_request["error"].split(",")
                }
            }
        }
    }
};
</script>
